import React, { useState, useEffect } from "react";

import { API, graphqlOperation } from "aws-amplify";
import { searchInventorys } from "../../../graphql/report-queries";

import { addMonths, format, getMonth, startOfMonth, sub } from "date-fns";

import {
  CartesianGrid,
  Line,
  LineChart,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import { Typography } from "@material-ui/core";

import { useNotify, TopToolbar } from "react-admin";

import { ForceTitle } from "../../../components/common/ForceTitle";
import { BackButton } from "../../../components/common/BackButton";
import { logError } from "../../../utils/appUtils";
import { InventoryStatus } from "../../../utils/constants";
import Title from "../Title";

const AvgInventoryTurnsByMonth = () => {
  const notify = useNotify();
  const [average, setAverage] = useState(0);
  const [data, setData] = useState([]);
  const dataMap = {};
  const height = window.innerHeight * 0.7;

  useEffect(() => {
    // Get the last 12 months, including current month
    const startDate = startOfMonth(sub(new Date(), { months: 11 }));

    for (let i = 0; i <= 11; i++) {
      const newDate = addMonths(startDate, i);
      const month = newDate.getMonth();
      const monthName = format(newDate, "MMM");
      dataMap[month] = { idx: i, name: monthName, count: 0, days: 0, avg: 0 };
    }

    getInventoryData(startDate);
  }, []);

  const getInventoryData = async (startDate) => {
    let tempData = [];
    debugger;

    try {
      const response = await API.graphql(
        graphqlOperation(searchInventorys, {
          // sort: {field: "depletedAt", direction: "asc"},
          filter: {
            reloadYardId: { eq: window.appUser?.reloadYardId },
            status: { eq: InventoryStatus.SHIPPED },
            and: [
              // { notifyDateTime: { lt: startDate }},
              { depletedAt: { gte: startDate } },
            ],
          },
          limit: 1000,
        }),
      );
      const items = response.data.searchInventorys.items;
      let totalAmt = 0;

      items.forEach((element) => {
        let elementMonth = getMonth(new Date(element.depletedAt));
        dataMap[elementMonth].count++;
        dataMap[elementMonth].days =
          dataMap[elementMonth].days + element.turnDays;
      });

      Object.keys(dataMap).forEach((month) => {
        tempData[dataMap[month].idx] = dataMap[month];
        if (dataMap[month].count > 0) {
          const avgDays = dataMap[month].days / dataMap[month].count;
          dataMap[month].avg = avgDays;
          totalAmt += avgDays;
        }
      });

      const avg = Math.round(totalAmt / tempData.length);

      setData(tempData);
      setAverage(avg);
    } catch (err) {
      logError("AverageInventoryTurnover:getInventoryData", err, notify);
    }
  };

  return (
    <>
      <div style={{ display: "none" }}>
        <ForceTitle title="Reports" />
      </div>
      <TopToolbar>
        <Title>Avg Inventory Turn Days by Month</Title>
        <BackButton basePath="/reports" />
      </TopToolbar>

      <ResponsiveContainer height={height}>
        <LineChart
          data={data}
          margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip
            content={({ payload }) => {
              if (payload && payload.length) {
                const { date, amt } = payload[0].payload;
                return (
                  <div
                    style={{
                      color: "black",
                      background: "white",
                      padding: "8px",
                      border: "1px solid black",
                    }}
                  >
                    <Typography>{`Date: ${date}`}</Typography>
                    <Typography>{`Value: ${amt}`}</Typography>
                    <Typography>{`Average: ${average}`}</Typography>
                  </div>
                );
              }
              return null;
            }}
          />
          {average && (
            <ReferenceLine
              y={average}
              stroke="red"
              strokeWidth={6}
              strokeDasharray="6 6"
            />
          )}
          <Line
            type="monotone"
            dataKey="avg"
            stroke="#8884d8"
            activeDot={{ r: 8 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </>
  );
};

export default AvgInventoryTurnsByMonth;
